import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BookingForm from './BookingForm';

const Header = () => {
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [activeItem, setActiveItem] = useState('/');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    setActiveItem(location.pathname);
  }, [location]);

  const menuItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/contact', label: 'Contact' }
  ];

  const handleClick = (path) => {
    setActiveItem(path);
    navigate(path);
    window.scrollTo(0, 0);
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [mobileMenuOpen]);

  return (
    <>
      <header>
        <div className="header-area">
          <div id="sticky-header" className="main-header-area">
            <div className="container-fluid p-0">
              <div className="row align-items-center no-gutters" style={{ minHeight: '80px' }}>
                
                <div className="col-xl-5 col-lg-6">
                  <div className="main-menu d-none d-lg-block">
                    <nav>
                      <ul id="navigation">
                        {menuItems.map((item) => (
                          <li key={item.path}>
                            <a
                              className={activeItem === item.path ? 'active' : ''}
                              href={item.path}
                              onClick={(e) => {
                                e.preventDefault();
                                handleClick(item.path);
                              }}
                              style={{ 
                                textDecoration: 'none',
                                position: 'relative'
                              }}
                            >
                              {item.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </nav>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6">
                  <div className="logo-img" style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '80px'
                  }}>
                    <a href="/" onClick={(e) => { e.preventDefault(); handleNavigation('/'); }}>
                      <img src="assets/img/logo.png" alt="" style={{ width: '120px', height: 'auto' }} />
                    </a>
                  </div>
                </div>

                <div className="col-xl-5 col-lg-4 d-none d-lg-block">
                  <div className="book_room">
                    <div className="socail_links">
                      <ul>
                        <li>
                          <a href="#">
                            <i className="fa fa-facebook-square"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fa fa-twitter"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fa fa-instagram"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="book_btn d-none d-lg-block">
                      {/*<a 
                        href="#" 
                        className="flex-c-m stext-101 cl0 size-101 bg1 bor1 hov-btn2 p-lr-15 trans-04" 
                        onClick={(e) => { 
                          e.preventDefault(); 
                          setShowBookingForm(true); 
                          setMobileMenuOpen(false);
                        }}
                      >  
                        Book Now
                      </a>*/}
                       <a 
                        href="" 
                        className="flex-c-m stext-101 cl0 size-101 bg1 bor1 hov-btn2 p-lr-15 trans-04" 
                       
                      >
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-xl-5 col-lg-4 col-md-6 col-sm-6 d-block d-lg-none">
                  <div className="mobile-menu-wrapper" style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'flex-end',
                    height: '80px',
                    paddingRight: '20px'
                  }}>
                    <div 
                      className="mobile-nav-toggle" 
                      onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                      style={{
                        fontSize: '24px',
                        cursor: 'pointer',
                        color: '#fff',
                        padding: '10px',
                        zIndex: 1001
                      }}
                    >
                      {mobileMenuOpen ? '✕' : '☰'}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div 
            className="mobile-menu-overlay"
            onClick={() => setMobileMenuOpen(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 999
            }}
          ></div>
        )}

        <nav 
          className={`mobile-nav ${mobileMenuOpen ? 'mobile-nav-open' : ''}`}
          style={{
            position: 'fixed',
            top: 0,
            right: mobileMenuOpen ? 0 : '-300px',
            width: '300px',
            height: '100%',
            backgroundColor: 'white',
            zIndex: 1000,
            transition: 'right 0.3s ease',
            padding: '60px 20px 20px',
            boxShadow: '-5px 0 15px rgba(0,0,0,0.1)'
          }}
        >
          <ul 
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}
          >
            {menuItems.map((item) => (
              <li key={item.path} style={{ marginBottom: '15px' }}>
                <a
                  className={activeItem === item.path ? 'active' : ''}
                  href={item.path}
                  onClick={(e) => {
                    e.preventDefault();
                    handleClick(item.path);
                  }}
                  style={{ 
                    textDecoration: 'none',
                    display: 'block',
                    padding: '10px 15px',
                    color: '#333',
                    fontSize: '18px',
                    fontWeight: activeItem === item.path ? 'bold' : 'normal',
                    borderBottom: '1px solid #eee'
                  }}
                >
                  {item.label}
                </a>
              </li>
            ))}
            
            {/* Social links mobile */}
            <li style={{ marginTop: '30px', padding: '15px' }}>
              <div className="socail_links">
                <ul style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                  <li>
                    <a href="#">
                      <i className="fa fa-facebook-square" style={{ fontSize: '20px' }}></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa fa-twitter" style={{ fontSize: '20px' }}></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa fa-instagram" style={{ fontSize: '20px' }}></i>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            
            {/* Book Now mobile */}
            <li style={{ padding: '15px' }}>
              {/*<a 
                href="#" 
                className="flex-c-m stext-101 cl0 size-101 bg1 bor1 hov-btn2 p-lr-15 trans-04" 
                style={{
                  display: 'block',
                  textAlign: 'center',
                  padding: '12px',
                  backgroundColor: '#333',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '5px'
                }}
                onClick={(e) => { 
                  e.preventDefault(); 
                  setShowBookingForm(true); 
                  setMobileMenuOpen(false);
                }}
              >
                Book Now
              </a>*/}
              <a 
                href="" 
                className="flex-c-m stext-101 cl0 size-101 bg1 bor1 hov-btn2 p-lr-15 trans-04" 
                style={{
                  display: 'block',
                  textAlign: 'center',
                  padding: '12px',
                  backgroundColor: '#333',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '5px'
                }}
                
              >
                Book Now
              </a>
            </li>
          </ul>
        </nav>
      </header>

      {showBookingForm && (
        <BookingForm onClose={() => setShowBookingForm(false)} />
      )}
    </>
  );
};

export default Header;